import React, { useState } from 'react';
import FLogo from "../components/img/FLogo.png";
import '@fortawesome/fontawesome-free/css/all.min.css';

const Footer = () => {
  // Modal open/close ke liye state
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const toggleDisclaimer = (e) => {
    e.preventDefault();
    setShowDisclaimer(!showDisclaimer);
  };

  return (
    <>
      <style>
        {`
          /* Premium Footer based on your Original CSS */
          #premium-footer.footer {
            background: linear-gradient(180deg, #151518 0%, #0a0a0c 100%);
            color: #ffffff;
            display: flex;
            flex-wrap: wrap;
            padding: 60px 40px 30px 40px;
            justify-content: space-between;
            align-items: flex-start;
            text-align: left;
            border-top: 1px solid rgba(255, 255, 255, 0.05);
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          }

          #premium-footer .footer-section {
            flex: 1 1 220px;
            margin: 10px 20px;
          }

          #premium-footer .footer-logo {
            max-width: 180px;
            margin-bottom: 20px;
            filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.4));
          }

          #premium-footer h5 {
            font-size: 1.25rem;
            font-weight: 700;
            margin-bottom: 15px;
            background: linear-gradient(135deg, #00a8e8, #ec1c74);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            letter-spacing: 0.5px;
          }

          #premium-footer h3 {
            border-bottom: 2px solid rgba(236, 28, 116, 0.4);
            padding-bottom: 10px;
            margin-bottom: 20px;
            font-size: 1.2rem;
            color: #f5f5f7;
            font-weight: 600;
            display: inline-block;
          }

          #premium-footer p,
          #premium-footer a,
          #premium-footer span {
            color: #a1a1a6;
            font-size: 0.95rem;
            line-height: 1.8;
            margin: 5px 0;
            text-decoration: none;
            transition: all 0.3s ease;
          }

          /* Zoom & Brand Color effect */
          #premium-footer a:hover {
            color: #00a8e8; /* Logo Blue */
            transform: translateX(5px);
            display: inline-block;
            cursor: pointer;
          }

          #premium-footer .contact-us p {
            color: #a1a1a6;
          }

          #premium-footer .quick-links ul {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          #premium-footer .quick-links ul li {
            margin: 12px 0;
          }

          #premium-footer .social-icons {
            display: flex;
            gap: 15px;
            margin-top: 10px;
          }

          #premium-footer .social-icons a {
            color: #a1a1a6;
            font-size: 1.4rem;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background: rgba(255, 255, 255, 0.03);
            border-radius: 8px;
            border: 1px solid rgba(255, 255, 255, 0.05);
          }

          #premium-footer .social-icons a:hover {
            color: #ffffff;
            background: #ec1c74; /* Logo Pink */
            border-color: #ec1c74;
            transform: translateY(-5px);
            box-shadow: 0 10px 20px rgba(236, 28, 116, 0.3);
          }

          #premium-footer .opening-hours i {
            width: 25px;
            color: #00a8e8; /* Logo Blue for icons */
          }

          #premium-footer .copyright {
            width: 100%;
            text-align: center;
            margin-top: 40px;
            padding-top: 20px;
            border-top: 1px solid rgba(255, 255, 255, 0.05);
          }

          #premium-footer .copyright p {
            font-size: 0.9rem;
            color: #6e6e73;
          }

          /* --- Medical Disclaimer Popup Animation & Styling --- */
          .disclaimer-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.75);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
            opacity: 0;
            animation: fadeIn 0.3s ease-out forwards;
            backdrop-filter: blur(4px);
          }

          .disclaimer-modal {
            background: #151518;
            border: 1px solid rgba(236, 28, 116, 0.4);
            padding: 30px;
            border-radius: 12px;
            max-width: 450px;
            width: 90%;
            text-align: center;
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.6);
            transform: scale(0.9) translateY(20px);
            animation: slideUpScale 0.4s ease-out forwards;
          }

          .disclaimer-modal h3 {
            color: #ffffff;
            margin-top: 0;
            border: none;
            padding-bottom: 0;
            margin-bottom: 15px;
          }

          .disclaimer-modal p {
            color: #a1a1a6;
            margin-bottom: 25px;
            font-size: 1.05rem;
          }

          .close-btn {
            background: linear-gradient(135deg, #00a8e8, #ec1c74);
            color: white;
            border: none;
            padding: 10px 25px;
            border-radius: 6px;
            cursor: pointer;
            font-weight: 600;
            font-size: 1rem;
            transition: transform 0.2s, box-shadow 0.2s;
          }

          .close-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(236, 28, 116, 0.4);
          }

          @keyframes fadeIn {
            to { opacity: 1; }
          }

          @keyframes slideUpScale {
            to { transform: scale(1) translateY(0); }
          }

          /* Responsive based on your original media queries */
          @media (max-width: 768px) {
            #premium-footer.footer {
              flex-direction: column;
              text-align: left;
              padding: 40px 20px;
            }

            #premium-footer .footer-section {
              flex: 1 1 100%;
              margin: 15px 0;
            }

            #premium-footer .social-icons {
              justify-content: flex-start;
            }
          }

          @media (max-width: 480px) {
            #premium-footer h3 {
              font-size: 1.1rem;
            }

            #premium-footer p,
            #premium-footer a {
              font-size: 0.9rem;
            }

            #premium-footer .social-icons a {
              font-size: 1.2rem;
              width: 35px;
              height: 35px;
            }
          }
        `}
      </style>

      <footer id="premium-footer" className="footer">
        
        {/* Section 1: Brand & About */}
        <div className="footer-section contact-us">
          <img src={FLogo} alt="Maa Sadhana Logo" className="footer-logo" />
          <h5>Maa Sadhana Foundation Wellness Center</h5>
          <p className="text-footer-p">
            At Maa Sadhana Foundation, we provide a safe and supportive space for individuals seeking a healthier, balanced life. Our mission is to help them achieve complete wellness through counseling, holistic care, and vocational training. We aim to guide each person towards healing, self-reliance, and a brighter future. Join us in creating a healthier, balanced world.
          </p>
        </div>

        {/* Section 2: Quick Links */}
        <div className="footer-section quick-links">
          <br />
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/our-treatment-facility">Facility</a></li>
            <li><a href="/image-gallery">Image Gallery</a></li>
            <li><a href="/video-gallery">Video Gallery</a></li>
            <li><a href="/contact-us">Contact Us</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            {/* Added Medical Disclaimer Link Below Privacy Policy */}
            <li><a href="#" onClick={toggleDisclaimer}>Medical Disclaimer</a></li>
          </ul>
        </div>

        {/* Section 3: Social Media */}
        <div className="footer-section opening-hours">
          <br />
          <h3>Follow Us on Social Media</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/maa.s.rc.5?mibextid=ZbWKwL" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.instagram.com/caremstrecovery/?utm_source=qr&igsh=ODF4c2JrY2c3cTBk#" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
        
        {/* Section 4: Contact Info & Location */}
        <div className="footer-section opening-hours">
          <br />
          <h3>Contact Us</h3>
          
          <p>
            <a rel="nofollow" className="component-target" href="tel:+917535807012">
              <i className="fa fa-phone"></i>
              <span className="component-target-text">+91 7535807012</span>
            </a>
          </p>
          
          <p>
            <a rel="nofollow" className="component-target" href="tel:+917535807008">
              <i className="fa fa-phone"></i>
              <span className="component-target-text">+91 7535807008</span>
            </a>
          </p>

          <br />
          <h3>Location</h3> 
          <p>Visit us at our location:</p>
          <p>
            <i className="fas fa-map-marker-alt"></i>
            <span>NH-2, Delhi - Mathura Hwy, near Heera lal ki Pyau, Sikandra, Agra, Uttar Pradesh 282007</span>
          </p>
        </div>

        {/* Copyright Bar */}
        <div className="copyright">
          <p>© 2024 Maa Sadhana Foundation Wellness Center | All rights reserved.</p>
        </div>
        
      </footer>

      {/* Animated Medical Disclaimer Modal */}
      {showDisclaimer && (
        <div className="disclaimer-overlay" onClick={toggleDisclaimer}>
          {/* stopPropagation is used so clicking inside the modal doesn't close it */}
          <div className="disclaimer-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Medical Disclaimer</h3>
            <p>We do not provide medical advice. We are a counseling and wellness center.</p>
            <button className="close-btn" onClick={toggleDisclaimer}>Close</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;